(function() {
    'use strict';
    function MwMapController($window, $timeout, $scope, $compile, MAPBOX_API_TOKEN, $translate, MapService, $rootScope) {
        var _this = this;
        _this.map = null;

        this.$compile = $compile;
        this.$scope = $scope;
        this.$window = $window;
        this.geoCoder = null;
        this.$translate = $translate;
        this.MapService = MapService;
        this.$rootScope = $rootScope;

        // unique ID so we can use this component multiple times on a page
        _this.mapIdSelector = $scope.$id;
        _this.minZoom = _this.minZoom || 0;
        _this.maxZoom = _this.maxZoom || 12;

        function initializeMap() {
            $window.mapboxgl.accessToken = MAPBOX_API_TOKEN;

            ///
            //  -_-_-_- GeoCoDeR IniT -_-_-_-
            ///
            // We need to users language before we start initializing the geocoder
            _this.MapService.getUsersMBLanguage().then(function weHaveAnMBLanguage(supportedLanguage) {
                var geocoderOptions = {accessToken: $window.mapboxgl.accessToken, flyTo: false, placeholder: _this.getGeocoderPlaceholderText()};

                // Toss on a language if map box supports it
                if (supportedLanguage) {
                    geocoderOptions.language = supportedLanguage;
                }

                // Geocoder initialization!!
                _this.geoCoder = new $window.MapboxGeocoder(geocoderOptions);

                // Handle a result
                _this.geoCoder.on('result', function(ev) {
                    _this.MapService.setGeoCoderText(ev.result.place_name); // jshint ignore:line
                    _this.geoCoder.setInput(ev.result.place_name); // jshint ignore:line
                    if(ev && ev.result && ev.result.bbox){
                        map.fitBounds(ev.result.bbox, {animate: false});
                        _this.updateSearchClicked();
                    } else if (ev && ev.result && ev.result.geometry && ev.result.geometry.coordinates) {
                        map.flyTo({speed: 999, center: ev.result.geometry.coordinates, zoom: 13});
                        _this.updateSearchClicked();
                    }
                });

                // Handle that clear
                _this.geoCoder.on('clear', function() {
                    if (_this.searchUpdated) {
                        _this.MapService.setInteractionState(_this.MapService.SHOW_BUTTON);
                    }
                    else {
                        _this.MapService.setInteractionState(_this.MapService.HELPER_TEXT);
                    }

                    _this.searchUpdated = false;

                    _this.MapService.setGeoCoderText('');
                });
            });

            ///
            //  -_-_-_- mAp IniT -_-_-_-
            ///
            var map = new $window.mapboxgl.Map({
                container: 'map-container-' + _this.mapIdSelector,
                style: 'mapbox://styles/icm-meltwater/cj7uw19np2ow42so4lci9aj5h',
                maxZoom: 12
            });


            _this.MapService.registerMap(map);

            map.on('load', () => {
                // we need to wait until we get the units back before drawing all of the controls
                // units depend on the current company. retrieving that is promise based.
                _this.MapService.getScaleUnits().then(function(scaleUnits) {
                    map.addControl(new $window.mapboxgl.ScaleControl({unit: scaleUnits}), 'bottom-right');

                    // Add zoom and rotation controls to the map
                    map.addControl(new $window.mapboxgl.NavigationControl(), 'bottom-right');

                    // add the search functionality to the map
                    map.addControl(_this.geoCoder, 'top-left');

                    // sometimes there is a provided callback to further customize the map
                    if(_this.onMapInit && (typeof(_this.onMapInit) === 'function')) {
                        _this.onMapInit({map: map});
                    }

                    if(_this.startingBounds && !_this.MapService.getViewportBounds()){
                        _this.settingMapDefaultView = true;
                        _this.MapService.boundsSelected(_this.startingBounds);
                        $timeout(()=>{
                            map.fitBounds(_this.startingBounds, {animate: false});
                        }, 0);
                    }
                });

                map.on('dragstart', function() {
                    _this.setInteractState();
                });

                map.on('dragend', (ev)=>{
                    setBounds(ev);
                });

                map.on('zoomstart', ()=>{
                    _this.setInteractState();
                });

                map.on('zoomend', (ev)=>{
                    if(_this.startingZoom !== ev.target.getZoom()) {
                        _this.setInteractState();
                        setBounds(ev);
                    }

                    _this.settingMapDefaultView = false;
                });

                // disable map rotation using right click + drag
                map.dragRotate.disable();

                // disable map rotation using touch rotation gesture
                map.touchZoomRotate.disableRotation();

                // Set the maps language once its all loaded up
                _this.setLanguage();
            });

            return map;
        }

        function setBounds(e) {
            _this.MapService.boundsSelected(e.target.getBounds());
        }

        function clearGeoCoder(geoCoder) {
            if(geoCoder){
                geoCoder._clear();
                geoCoder._inputEl.blur();
            }
        }

        this.fitBounds = function fitBounds(bounds){ // jshint ignore:line
            if(this.map && bounds && bounds._ne && bounds._ne.lng && bounds._ne.lat && bounds._sw && bounds._sw.lng && bounds._sw.lat){
                this.map.fitBounds(bounds, {animate: false}); // jshint ignore:line
            }
        };

        this.$onChanges = function $onChanges(changes){
            if(this.geoCoder && changes.mapSearchText && changes.mapSearchText.currentValue === ''){
                clearGeoCoder(this.geoCoder);
            }
        };

        // this will attach itself to both the expansion map and the modal map
        // need to differentiate between the two
        $rootScope.$on('clearLocationFilter', ()=>{
            clearGeoCoder(this.geoCoder);
            this.fitBounds(this.startingBounds);
            this.MapService.setInteractionState(this.MapService.HELPER_TEXT);
        });

        $timeout(() => {
            if($window.mapboxgl.supported()) {
                this.MapService.isMapSupported = true;
                _this.map = initializeMap();

                // Tell map service about the mininap like so...
                this.MapService.registerMiniMapBoundsSetter(function(bounds) {
                    _this.fitBounds(bounds);
                }.bind(this));
                this.MapService.registerMiniMapBoundsGetter(function() {
                    return _this.map.getBounds();
                }.bind(this));

                if(this.MapService.getViewportBounds()){
                    _this.fitBounds(this.MapService.getViewportBounds().getBounds());
                }
                else if (this.MapService.getCachedViewportBounds()) {
                    _this.fitBounds(this.MapService.getCachedViewportBounds());
                }
            } else {
                this.MapService.isMapSupported = false;
            }
        }, 0);

        _this.getGeocoderPlaceholderText = function getGeocoderPlaceholderText() {
            return _this.$translate.instant('icm-search__location-filter--placeholder-label');
        };

        // Set maps language based on user
        _this.setLanguage = function() {
            var layersToUpdate = _this.MapService.MAPBOX_LAYERS_TO_UPDATE_LANGUAGE;
            // Set the language of the map based on users language
            this.MapService.getUsersMBLanguage().then(function gotUsersMBLanguage(supportedLanguage){
                if (supportedLanguage) {
                    layersToUpdate.forEach(function(layer) {
                        _this.map.setLayoutProperty(layer, 'text-field', ['get', 'name_' + supportedLanguage]);
                    });
                }
            });
        };
    }

    MwMapController.prototype.setInteractState = function setInteractState(){
        if (!this.settingMapDefaultView) {
            this.MapService.setInteractionState(this.MapService.SHOW_BUTTON);
        }
    };

    angular
        .module('MW.ContactManager.MwMap', [
            'MW.Configuration',
            'MW.Influencers.MapService'
        ])
        .component('mwMap', {
            bindings: {
                onMapInit: '&',
                viewport: '<',
                mapSearchText: '<',
                mapBoundsChanged: '&',
                startingBounds: '<',
                updateSearchClicked: '&'
            },
            controller: ['$window', '$timeout', '$scope', '$compile', 'MAPBOX_API_TOKEN', '$translate', 'MapService', '$rootScope', MwMapController],
            template: `
                <div id="map-container-{{$ctrl.mapIdSelector}}" class="map-container">
                </div>
            `
        });
}());
